<div class="header">
  {{ actionButtonList[actionButton].header }}
  <va-icon size="medium" class="collapse" name="close" (click)="destroyModal()">
  </va-icon>
</div>

<div class="content">
  <div *ngIf="isCurrentAnalysisSaved" class="exit-without-saving-warning">
    {{ exitWithoutSavingMsg }}
  </div>
  <div [ngClass]="{ 'delete-content': actionButton === 'delete' }">
    {{ actionButtonList[actionButton].content_header }}
    <input
      *ngIf="actionButton !== 'delete'"
      nz-input
      #templateInput
      class="template-name-input"
      [value]="templateName"
    />
    <div *ngIf="isDuplicateName" class="duplicate-error-msg">
      <va-icon
        size="small"
        name="exclamation-triangle"
        class="icon va-icon"
      ></va-icon>
      {{ duplicateErrorMsg }}
    </div>
  </div>
</div>

<div class="footer">
  <div class="action-button-container">
    <div>
      <button
        nz-button
        class="exit-without-saving-btn"
        (click)="onExitWithoutSavingClick()"
        [ngClass]="{ 'hide-btn': !isCurrentAnalysisSaved }"
      >
        Exit without saving
      </button>
    </div>
    <div class="default-button-container">
      <button nz-button class="cancel-btn" (click)="destroyModal()">
        Cancel
      </button>
      <button
        nz-button
        class="save-as-btn"
        (click)="onSaveAsOrDeleteClick(this)"
      >
        <span *ngIf="actionButton !== 'delete'">Save as</span>
        <span *ngIf="actionButton === 'delete'">Delete</span>
      </button>
    </div>
  </div>
</div>
